import { CustomizerDataType } from "../../Types/Layout/ThemeCustomizerTypes";

export const navLinkList: CustomizerDataType[] = [
    {
        path: 'https://support.pixelstrap.com/',
        image: '2.png',
        name: 'Support'
    },
    {
        path: 'https://docs.pixelstrap.net/react/crocs/document',
        image: '3.png',
        name: 'Document'
    },
    {
        path: 'https://landing.pixelstrap.net/react/crocs/template',
        image: '4.png',
        name: 'Check Features'
    },
    {
        path: 'https://themeforest.net/user/pixelstrap/portfolio',
        image: '5.png',
        name: 'Buy Now'
    }
]

export const lightColorData = [
    {
        primary:"#5C61F2",
        secondary:"#FF9766"
    },
    {
        primary:"#33BFBF",
        secondary:"#FF6150"
    },
    {
        primary:"#006666",
        secondary:"#FE6A49"
    },
    {
        primary:"#7A70BA",
        secondary:"#48A3D7"
    },
    {
        primary:"#6271EB",
        secondary:"#FF8575"
    },
    {
        primary:"#3949ab",
        secondary:"#4fc3f7"
    }
]

export const darkColorData = [
    {
        primary:"#4466f2",
        secondary:"#1ea6ec"
    },
    {
        primary:"#33BFBF",
        secondary:"#FF6150"
    },
    {
        primary:"#006666",
        secondary:"#FE6A49"
    },
    {
        primary:"#7A70BA",
        secondary:"#48A3D7"
    },
    {
        primary:"#6271EB",
        secondary:"#FF8575"
    },
    {
        primary:"#3949ab",
        secondary:"#4fc3f7"
    }
]